module.exports = __webpack_public_path__ + "img/b_Rentrit_front_2.2ed7d891.jpeg";